import 'react-add-to-calendar/dist/react-add-to-calendar.css';

import React from 'react';
import ReactAddToCalendar, { AddToCalendarProps as ReactAddToCalendarProps } from 'react-add-to-calendar';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';

const styles = ({ spacing: { unit }, palette: { secondary } }: Theme) =>
  createStyles({
    root: {
      '& a:not([href]):not([tabindex])': {
        color: secondary.main,
        textDecoration: 'underline',
        padding: 0,
        fontWeight: 600,
      },
      '& .react-add-to-calendar__button': {
        border: 'none',
        backgroundColor: 'transparent',
      },
      '& .react-add-to-calendar__dropdown': {
        boxShadow: 'none',
        position: 'relative',
        top: unit,
      },
      '& ul': {
        paddingInlineStart: 0,
      },
    },
  });

const messages = defineMessages({
  buttonLabel: {
    id: 'app.components.AddToCalendar.buttonLabel',
    defaultMessage: 'Add to Calendar',
  },
});

interface AddToCalendarProps extends ReactAddToCalendarProps, WithStyles<typeof styles> {}

const AddToCalendar: React.FC<AddToCalendarProps> = ({ classes, ...rest }) => {
  const { formatMessage } = useIntl();
  return (
    // stopPropagation is a quick fix. Check https://app.clickup.com/t/2e5e0an for the actual fix
    <div className={classes.root} onClick={(event) => event.stopPropagation()}>
      <ReactAddToCalendar
        buttonLabel={formatMessage(messages.buttonLabel)}
        buttonTemplate={{ textOnly: 'none' }}
        listItems={[{ google: 'Google' }, { outlook: 'Outlook' }, { apple: 'Apple' }]}
        {...rest}
      />
    </div>
  );
};

export default withStyles(styles)(AddToCalendar);
